module.exports = __webpack_public_path__ + "img/lightrain.bfe42dee.png";